/**
 * @author sukim91
 * @date 2022-10-06 14:37
 * @remark Validator
 * @props None
 */
export abstract class Validator {
    private _valid: boolean | null = null;

    constructor() {
    }

    /**
     * @getter
     */
    get isValid() {
        return this._valid;
    }

    /**
     * @setter
     */
    set valid(v : boolean) {
        this._valid = v;
    }
}